<fe-header style="z-index: 10000"></fe-header>
<main>
    <section class="landing__vacation__top position-relative d-flex">
        <img
            class="container-fluid px-0 d-none d-sm-flex"
            alt="Alamo vacation Horizontal"
            [src]="'images/devacacionesconalamo.webp' | cdn"
        />
        <img
            class="container-fluid px-0 d-flex d-sm-none"
            alt="Alamo vacation Vertical"
            [src]="'images/bannervacations.webp' | cdn"
        />
    </section>
    <section
        class="landing__vacation__middle py-2 d-flex align-items-center justify-content-center"
    ></section>
    <section class="landing__vacation__search py-2">
        <div class="container py-4 px-1 px-lg-8">
            <fe-search-reservation
                [container]="'container-fluid'"
                [isNormal]="true"
            ></fe-search-reservation>
        </div>
    </section>
    <section
        class="landing__vacation__bottom py-2 d-flex align-items-center justify-content-center"
    >
        <div class="container py-4 px-0 px-md-2 px-lg-8">
            <h1>
                {{ 'fe_landing_vacation_title' | translate }}
            </h1>
            <div
                class=""
                [innerHTML]="'fe_landing_vacation_text_1' | translate"
            ></div>
            <h3 class="mt-4">
                {{ 'fe_landing_vacation_subtitle_1' | translate }}
            </h3>
            <div [innerHTML]="'fe_landing_vacation_text_2' | translate"></div>
            <h3 class="mt-4">
                {{ 'fe_landing_vacation_subtitle_2' | translate }}
            </h3>
            <div
                class=""
                [innerHTML]="'fe_landing_vacation_text_3' | translate"
            ></div>
            <h3 class="mt-4">
                {{ 'fe_landing_vacation_subtitle_3' | translate }}
            </h3>
            <div
                class=""
                [innerHTML]="'fe_landing_vacation_text_4' | translate"
            ></div>
            <h3 class="mt-4">
                {{ 'fe_landing_vacation_subtitle_4' | translate }}
            </h3>
            <ul>
                <li>{{ 'fe_landing_vacation_li_1' | translate }}</li>
                <li>{{ 'fe_landing_vacation_li_2' | translate }}</li>
                <li>{{ 'fe_landing_vacation_li_3' | translate }}</li>
                <li>{{ 'fe_landing_vacation_li_4' | translate }}</li>
                <li>{{ 'fe_landing_vacation_li_5' | translate }}</li>
            </ul>
            <div
                class=""
                [innerHTML]="'fe_landing_vacation_text_5' | translate"
            ></div>
            <p>{{ 'fe_landing_vacation_text_6' | translate }}</p>
        </div>
    </section>
</main>
<fe-footer></fe-footer>
